const best_practices = `Wir haben auf <a href="https://github.com/dpa-newslab" target="_blank">Github Best Practices</a> für die Anbindung unserer APIs veröffentlicht.

**HINWEIS**: Es handelt sich um Beispielimplementierungen, die Sie für die produktive Nutzung an Ihre Gegebenheiten und Systeme anpassen sollten!

### s3push Anbindung

Es stehen folgende Referenzimplementierungen für die s3push-API zur Verfügung:

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-s3push-example" target="_blank">s3push-Empfang via AWS, Konvertierung in anderes Format mit AWS-Lambda-Funktionen (JavaScript)</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-s3push-wordpress" target="_blank">s3push-Empfang via AWS, Weiterleitung an WordPress-REST-API (JavaScript, PHP)</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-s3push-webhook" target="_blank">s3push-Empfang via AWS, Weiterleitung an CMS-API-Endpunkt, mit asynchronem Import-Status-Check (Python)</a>

### wireQ-API Anbindung

Es stehen folgende Referenzimplementierungen für die wireQ-API zur Verfügung:

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-wireq-example" target="_blank">Abfrage der wireQ-API (GET/DELETE- oder POST-Ablauf) und Speichern im lokalen Filesystem (Python)</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-wireq-wordpress-plugin" target="_blank">WordPress-Plugin für wireQ-Abruf und Import via WordPress-Cronjob</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-wireq-java-example" target="_blank">Abfrage der wireQ-API (GET/DELETE- oder POST-Ablauf) und Weiterleiten an ActiveMQ (Java)</a>

### Konvertierung von dpa-digitalwires in andere Formate

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-to-iptc7901" target="_blank">Eine Python-Bibliothek, die Einträge aus dem dpa-digitalwires-Format in ein angenähertes IPTC 7901-Artikelformat umwandelt</a>

### Eingebettete Inhalte via Web Components

Zur Darstellung von Social-Media-Embeds, Grafiken, positionierten Bildern und weiteren Multimedia-Inhalten innerhalb eines Artikels verwenden wir Web Components. Eine Referenzimplementierung befindet sich hier:

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-embeds" target="_blank">dpa-digitalwires-embeds</a>

Auf Basis dieser Referenzimplementierung oder eigener bereits existierender Web Components können Sie dann z. B. eine Integration der eingebetteten Inhalte in Ihre Content Management Platform realisieren (d.h. Opt-In, Two-Click, Opt-Out etc.)

### Sonstiges

In einem <a href="https://github.com/dpa-newslab/dpa-digitalwires-snippets" target="_blank">extra Repository</a> sammeln wir Code-Snippets für wiederkehrende, kleine Aufgaben mit dem dpa-digitalwires-Format.

* <a href="https://github.com/dpa-newslab/dpa-digitalwires-snippets/tree/main/table-of-contents" target="_blank">Erstellung eines Inhaltsverzeichnisses mit Deeplinks zu allen Zwischentiteln</a>
* <a href="https://github.com/dpa-newslab/dpa-digitalwires-snippets/tree/main/weblines-single-rubric-name" target="_blank">Auswahl der wichtigsten Weblines-Rubrik für einen mehrfach rubrizierten Artikel</a>
`

export { best_practices }


// WEBPACK FOOTER //
// ./src/all_cards/docu/best_practices.js